import React from 'react'
import WallModel from './WallModel'
import TrimModel from './TrimModel'

const Wall = () => {
    return (
        <>
            <WallModel />
            <TrimModel />
        </>
    )
}

export default Wall